// Generated by Melange

import StarButtonModuleCss from "./starButton.module.css";
import * as Belt__Belt_Option from "melange.belt/belt_Option.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Fetch from "melange-fetch/Fetch.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as Shared__Button from "./button.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__RunAsync from "../storeFx/runAsync.jsx";
import * as StoreFx__Star from "../storeFx/star.jsx";
import * as StoreFx__Unstar from "../storeFx/unstar.jsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = StarButtonModuleCss;

function StarButton(Props) {
  let albumId = Props.albumId;
  let artistId = Props.artistId;
  let className = Props.className;
  let disabled = Props.disabled;
  let id = Props.id;
  let starred = Props.starred;
  const runAsyncStoreFx = StoreFx__RunAsync.use(undefined);
  const match = React.useState(function () {
    return Stdlib__Fun.$$const(undefined, undefined);
  });
  const setStarredOptimisic = match[1];
  const starred$1 = Belt__Belt_Option.orElse(starred, match[0]);
  let tmp = {
    ariaLabel: "Favorite",
    ariaPressed: starred$1 !== undefined ? "true" : "false",
    children: JsxRuntime.jsx(LucideReact$1.Heart, Curry._4(LucideReact.Heart.makeProps, undefined, Stdlib__Option.map((function (param) {
      return css.icon;
    }), starred$1), "none", undefined)),
    variant: "icon",
    type_: "submit"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (disabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(disabled);
  }
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx("input", {
        name: "starred",
        type: "hidden",
        value: starred$1 !== undefined ? "" : "1"
      }),
      JsxRuntime.jsx(Shared__Button.make, tmp)
    ],
    className: css.root,
    role: "none",
    onSubmit: (function ($$event) {
      $$event.preventDefault();
      if (albumId === undefined && artistId === undefined && id === undefined) {
        return;
      }
      const newStarred = Stdlib__Option.map((function (param) {
        return new Date().toISOString();
      }), Stdlib__Option.bind(Stdlib__Option.map(Fetch.$$FormData.EntryValue.classify, new FormData($$event.currentTarget).get("starred")), (function (param) {
        if (param.NAME === "File" || param.VAL === "") {
          return;
        } else {
          return Caml_option.some(undefined);
        }
      })));
      Curry._1(setStarredOptimisic, (function (param) {
        return Stdlib__Fun.$$const(newStarred, param);
      }));
      const fx = newStarred !== undefined ? StoreFx__Star.make({
          albumId: albumId,
          artistId: artistId,
          id: id
        }) : StoreFx__Unstar.make({
          albumId: albumId,
          artistId: artistId,
          id: id
        });
      Curry._1(runAsyncStoreFx, fx).then(function (result) {
        Stdlib__Result.get_ok(result);
        Curry._1(setStarredOptimisic, (function (param) {
          return Stdlib__Fun.$$const(undefined, param);
        }));
        return Promise.resolve(undefined);
      });
    })
  });
}

const make = StarButton;

export {
  make,
}
/* css Not a pure module */
